import React from 'react';
import { Tooltip } from "@mui/material";
import { endpoint, regex } from "../../../../../views/pages/manage/common/constant";
import { ReactComponent as YellowInfoIcon } from "assets/img/svg/InfoCircle.svg";
import { ReactComponent as RedInfoIcon } from "assets/img/svg/InfoCircleRedFilled.svg";
import { transferTypes } from '../../../transferSetup/transferApprovalConfig/addEditCofigDialog/utils';
import { fetchAllPostPromisedData, removeKeysFromObject, updateRequest } from '../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

export const searchInputOptions = [
    {
        label: 'PSID',
        keyName: 'psid',
        placeholder: 'Search by PSID',
        errorMsg: 'Please Enter 11 digit PSID',
        regex: regex.numeric,
        isValidInput: val => val?.length === 11,
    },
    {
        label: 'Application ID',
        keyName: 'applicationId',
        placeholder: 'Search by Application ID',
        errorMsg: 'Please Enter 8 digit application ID',
        regex: regex.numeric,
        isValidInput: val => val?.length === 8,
    },
    {
        label: 'Student Name',
        keyName: 'studentName',
        placeholder: 'Search by Student Name',
        regex: regex.alphabetsWithSpace,
    },
]

export const statusFilterOptions = [
    { label: 'Rejected', value: 'REJECTED' },
    { label: 'Pending', value: 'In_PROGRESS' },
    { label: 'All', value: 'ALL' },
]

export const EMPTY_FILTER_FORM = {
    branchIds: [],
    termIds: [],
    academicGroupIds: [],
    transferTypes: [],
    fromDate: '',
    toDate: ''
}

export const getFilterFormFields = dropdownData => {
    const { businessAres, term, stream } = dropdownData;

    return [
        {
            label: 'Branch',
            type: 'select',
            items: businessAres,
            formKey: 'branchIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select branch",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Term',
            type: 'select',
            items: term,
            formKey: 'termIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Term",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Academic Group',
            type: 'select',
            items: stream,
            formKey: 'academicGroupIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Academic Group",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Transfer Types',
            type: 'select',
            items: transferTypes,
            formKey: 'transferTypes',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Academic Group",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Request Date From',
            type: 'date',
            formKey: 'fromDate',
            onChange: () => { },
            placeholder: "Select",
            disabled: false,
            minDate: '',
            maxDate: '',
        },
        {
            label: 'Request Date To',
            type: 'date',
            formKey: 'toDate',
            onChange: () => { },
            placeholder: "Select",
            disabled: false,
            minDate: '',
            maxDate: '',
        },
    ]
}

export const statusChipInfo = (status, info) => {

    const iconStyles = { width: "16px", height: "16px", marginLeft: '0.25rem' };
   
    const chipInfoMapping = {
        "IN_PROGRESS": {
            text: <span>In Progress</span>,
            bgColor: "#FFEDC8",
            textColor: "#A17217"
        },

        "Action Needed": {
            text: (
                <span>
                    Action Needed
                    <Tooltip title={info || "-"}>
                        <span><YellowInfoIcon style={iconStyles} /></span>
                    </Tooltip>
                </span>
            ),
            bgColor: "#FFEDC8",
            textColor: "#A17217"
        },

        "FAILURE": {
            text: (
                <span>
                    Rejected
                    <Tooltip title={info || "-"}>
                        <span><RedInfoIcon style={iconStyles} /></span>
                    </Tooltip>
                </span>
            ),
            bgColor: "#F9D9D7",
            textColor: "#B32306"
        },
        "REJECTED": {
            text: (
                <span>
                    Rejected
                    <Tooltip title={info || "-"}>
                        <span><RedInfoIcon style={iconStyles} /></span>
                    </Tooltip>
                </span>
            ),
            bgColor: "#F9D9D7",
            textColor: "#B32306"
        },
        "FAILURE": {
            text: (
                <span>
                    Failure
                    <Tooltip title={info || "-"}>
                        <span><RedInfoIcon style={iconStyles} /></span>
                    </Tooltip>
                </span>
            ),
            bgColor: "#F9D9D7",
            textColor: "#B32306"
        },

        "SUCCESS": {
            text: <span>Success</span>,
            bgColor: "#BBE2CE",
            textColor: "#0B442D"
        },
        "Processed": {
            text: <span>Processed</span>,
            bgColor: "#BBE2CE",
            textColor: "#0B442D"
        }
        
    };

    return chipInfoMapping[status];
};

export const searchTransferRequests = ({ dropdowns, filters, pageNo, pageSize }) => {
    const branchIds = filters?.branchIds?.length ? filters?.branchIds : dropdowns?.businessAres;
    const updatedFilters = {
        ...filters,
        branchIds
    }
    const req = updateRequest({ ...updatedFilters, pageNo, pageSize })
    return fetchAllPostPromisedData(endpoint.transferRequests.search, req);
}

export const updateTransferRequestsList = (list, dropdowns) => {
    const { businessAres } = dropdowns;
    return list?.map(el => ({
        ...el,
        businessArea: businessAres?.find(bu => bu?.value === el?.outBusinessUnitId)
    }))
}

export const getAppliedFilterCount = (filters = {} , fieldsToIgnore = []) => {

    const  updatedFilters = removeKeysFromObject({...filters}, fieldsToIgnore);
    let count = 0;

    Object.values(updatedFilters).forEach(val => {
        if(
            (Array.isArray(val) && val?.length > 0) ||
            (typeof val === 'string' && val.trim() !== '') ||
            (typeof val === 'object' && !Array.isArray(val) && val != null)
        ) count++;
    })

    return count;
}
